// because of redux toolkit copy Error as plain object
const SerializableError = <N extends string>(name: N) =>
  class E extends Error {
    readonly name = name;

    static is<T = E>(x: any): x is T {
      return x?.name === name;
    }
  };

export { SerializableError };
